// Instants Kiné stricts : aucune interprétation SQL legacy, aucun fuseau navigateur.
import calendar from './clinic-calendar'

export function clinicNow(date = new Date(), zone) {
    return civilString(civilParts(formatter(zone), date.getTime())).slice(0, 16)
}

export function utcInstant(value) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z$/.test(value)) throw Error('Instant UTC invalide')
    const date = new Date(value)
    if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 19) + 'Z' !== value) throw Error('Calendrier invalide')
    return date.getTime()
}
function formatter(zone) {
    if (typeof zone !== 'string' || !zone) throw Error('Fuseau clinique absent')
    try { return new Intl.DateTimeFormat('en-GB', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }) }
    catch (_) { throw Error('Fuseau clinique invalide : vérifiez les Paramètres.') }
}
function civilParts(format, ms) { return format.formatToParts(new Date(ms)).reduce((parts, part) => { if (part.type !== 'literal') parts[part.type] = part.value; return parts }, {}) }
function civilString(parts) { return `${parts.year}-${parts.month}-${parts.day}T${parts.hour}:${parts.minute}:${parts.second}` }
export function clinicalDate(value, zone) {
    const ms = utcInstant(value); formatter(zone)
    return new Intl.DateTimeFormat('fr-FR', { timeZone: zone, day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(new Date(ms))
}
export function localToUtc(value, zone) {
    if (typeof value !== 'string' || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?$/.test(value)) throw Error('Renseignez une date et une heure civiles exactes.')
    const civil = value.length === 16 ? value + ':00' : value, nominal = utcInstant(civil + 'Z'), format = formatter(zone), offsets = new Set()
    // Les offsets entourant le jour couvrent les transitions IANA (y compris demi-heures).
    for (let hours = -36; hours <= 36; hours += 3) {
        const probe = nominal + hours * 3600000, parts = civilParts(format, probe)
        offsets.add(utcInstant(civilString(parts) + 'Z') - probe)
    }
    const candidates = Array.from(offsets, offset => nominal - offset).filter(ms => civilString(civilParts(format, ms)) === civil)
    if (candidates.length !== 1) throw Error(candidates.length ? 'Cette heure est ambiguë dans le fuseau clinique. Choisissez une autre heure.' : 'Cette heure n’existe pas dans le fuseau clinique. Choisissez une autre heure.')
    return new Date(candidates[0]).toISOString().slice(0, 19) + 'Z'
}
export function clinicalDuration(seconds) { return Number.isInteger(seconds) && seconds >= 0 ? calendar.duration(seconds) : 'Temps indisponible' }
